import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const ProgressTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-self: center;
	align-items: center;
	width: 100%;
`;

export const ProgressTexts = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	width: 100%;
`;

export const ProgressText = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-grow: 1;
`;

// TEXT PROGRESS BAR
export const ProgressBarItemsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-self: center;
	align-items: center;
	width: 100%;
	margin-bottom: 32px;
`;
export const ProgressBarItems = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	width: 100%;
`;
export const ProgressBarItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-grow: 1;
	padding-bottom: 8px;
	background: ${CONFIG.colors.white};
	border-bottom: ${({ activeStep }) => {
		if (activeStep) {
			return `5px solid ${CONFIG.colors.primary}`;
		} else {
			return `5px solid ${CONFIG.colors.greyLight}`;
		}
	}};
`;
export const ProgressBarLabel = styled.p`
	font-size: ${CONFIG.fontSizes.md};
	fontfamily: ${CONFIG.fonts.semiBold};
	color: ${({ activeStep }) => {
		if (activeStep) {
			return CONFIG.colors.black;
		} else {
			return CONFIG.colors.greyLight;
		}
	}};
`;
